import LazyLoadImage from '@fingo/lib/components/images/LazyLoadImage';
import FingoNavbar from '@fingo/lib/components/layout/FingoNavbar';
import { LoggedOutNavItems } from '@fingo/lib/components/layout/navbar';
import LogoWithRedirectLink from '@fingo/lib/components/logo/LogoWithRedirectLink';
import { useGetUser, useIsLogged } from '@fingo/lib/hooks';
import React, { useMemo, Suspense } from 'react';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';
import BancoDeChileLogo from '@fingo/lib/assets/icons/logos/banco_de_chile';
import { lazy } from '@loadable/component';
import isOnlyLogoRoute from './OnlyLogoRoutes';

const LoggedInDesktopNavItems = lazy(() => import('./LoggedInDesktopNavItems'));
const DesktopNavbar = () => {
  const isLogged = useIsLogged();
  const user = useGetUser();
  const { pathname } = useLocation();
  const onlyLogoRoute = isOnlyLogoRoute(pathname);

  const logo = (
    <LogoWithRedirectLink
      image={(
        <LazyLoadImage
          src={BancoDeChileLogo}
          alt="banco-de-chile logo"
          width={212}
          height={34}
          format="avif"
        />
      )}
      isLogged={isLogged}
    />
  );
  const navbar = useMemo(() => (
    <FingoNavbar useGradient={false}>
      {onlyLogoRoute ? (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          {logo}
        </Box>
      ) : (
        <>
          {logo}
          {isLogged && user && (
            <Suspense fallback={null}>
              <LoggedInDesktopNavItems />
            </Suspense>
          )}
          {!isLogged && <LoggedOutNavItems title="Iniciar Sesión" to="/login" />}
        </>
      )}
    </FingoNavbar>

  ), [onlyLogoRoute, isLogged, user]);
  return navbar;
};

export default DesktopNavbar;
